export default {
  title: '商户管理',
  companyInfo: '企业信息',
  emailConfig: '邮箱配置',
  smsConfig: '短信配置',
  i18nManagement: '多语言管理',
  paymentAuthConfig: '支付与授权配置',
  systemSettings: '系统设置',
  roleManagement: '角色管理',
  accountManagement: '账号管理',
  operationLog: '操作日志',
};
